import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  successData: null,

  bookingList: [],
  bookingTotal: 0,

  statusHistory: [],
  historyLoading: false,

  transactionList: [],
  transactionTotal: 0,
  transactionLoading: false,
  outstanding: [],
  bookingReport: [],
  bookingReportTotal: 0,
  bookingReportPage: 1,
  bookingReportLimit: 10,
  bookingReportTotalPages: 0,
  bookingReportLoading: false,
  transactionSummary: null,
  transactionSummaryLoading: false,
};

const bookingBullionSlice = createSlice({
  name: "bookingBullion",
  initialState,
  reducers: {
    getBookingBullionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getBookingBullionSuccess: (state, action) => {
      state.loading = false;
      state.bookingList = action.payload?.contents || [];
      state.bookingTotal = action.payload?.total || 0;
    },
    getBookingBullionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveBookingBullionRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.successData = null;
    },
    saveBookingBullionSuccess: (state, action) => {
      state.loading = false;
      state.successData = action.payload;
    },
    saveBookingBullionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    clearBookingBullionState: (state) => {
      state.loading = false;
      state.error = null;
      state.successData = null;
    },
    getBookingStatusHistoryRequest: (state) => {
      state.historyLoading = true;
    },

    getBookingStatusHistorySuccess: (state, action) => {
      state.historyLoading = false;
      state.statusHistory = action.payload || [];
    },

    getBookingStatusHistoryFailure: (state, action) => {
      state.historyLoading = false;
      state.error = action.payload;
    },
    updateBookingStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    updateBookingStatusSuccess: (state, action) => {
      state.loading = false;
      state.successData = action.payload;
    },

    updateBookingStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    revokeBookingRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    revokeBookingSuccess: (state, action) => {
      state.loading = false;
      state.successData = action.payload;
    },

    revokeBookingFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    getTransactionRequest: (state) => {
      state.transactionLoading = true;
      state.error = null;
    },

    getTransactionSuccess: (state, action) => {
      state.transactionLoading = false;
      state.transactionList = action.payload?.transactions || [];

      state.transactionTotal = action.payload?.total || 0;
      state.outstanding = action.payload?.outstanding || [];
    },

    getTransactionFailure: (state, action) => {
      state.transactionLoading = false;
      state.error = action.payload;
    },
    getBookingReportRequest: (state) => {
      state.bookingReportLoading = true;
      state.error = null;
    },

    getBookingReportSuccess: (state, action) => {
      state.bookingReportLoading = false;

      state.bookingReport = action.payload?.data || [];

      state.bookingReportTotal = action.payload?.pagination?.total || 0;

      state.bookingReportPage = action.payload?.pagination?.page || 1;

      state.bookingReportLimit = action.payload?.pagination?.limit || 10;

      state.bookingReportTotalPages =
        action.payload?.pagination?.totalPages || 0;
    },
    getBookingReportFailure: (state, action) => {
      state.bookingReportLoading = false;
      state.error = action.payload;
    },
    getTransactionSummaryRequest: (state) => {
      state.transactionSummaryLoading = true;
      state.error = null;
    },

    getTransactionSummarySuccess: (state, action) => {
      state.transactionSummaryLoading = false;
      state.transactionSummary = action.payload || null;
    },

    getTransactionSummaryFailure: (state, action) => {
      state.transactionSummaryLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getBookingBullionRequest,
  getBookingBullionSuccess,
  getBookingBullionFailure,
  saveBookingBullionRequest,
  saveBookingBullionSuccess,
  saveBookingBullionFailure,
  getBookingStatusHistoryRequest,
  getBookingStatusHistorySuccess,
  getBookingStatusHistoryFailure,
  updateBookingStatusRequest,
  updateBookingStatusSuccess,
  updateBookingStatusFailure,
  revokeBookingRequest,
  revokeBookingSuccess,
  revokeBookingFailure,
  getTransactionRequest,
  getTransactionSuccess,
  getTransactionFailure,
  getBookingReportRequest,
  getBookingReportSuccess,
  getBookingReportFailure,
  getTransactionSummaryRequest,
  getTransactionSummarySuccess,
  getTransactionSummaryFailure,

  clearBookingBullionState,
} = bookingBullionSlice.actions;

export default bookingBullionSlice.reducer;
